import { axios } from 'libs';

const resource = '/processos-caixa';

export const getProcessosByCaixa = id => {
  return axios.get(`${resource}/processos/${id}`);
};

export const getImpressao = id => {
  const queryString = String(id).startsWith('?')
    ? String(id).slice(1)
    : String(id);
  const search = new URLSearchParams(queryString);
  const params = Object.fromEntries(search.entries());

  if (params.codigo !== null) params.codigo = Number(params.codigo);
  if (params.ano !== null) params.ano = Number(params.ano);

  return axios
    .post(`${resource}/impressao/pdf`, null, {
      params,
      responseType: 'blob'
    })
    .then(({ data }) => {
      const blob = new Blob([data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
      return { ok: true };
    });
};
